

export const obtenerProximoPremio = ({items=[], puntos}) =>{

    let item = items[0]

    for (let i = 0; i < items.length; i++) {
        if (puntos > items[i].valor) {

            if (i <= items.length) {
                item = items[i + 1]
            }else{
                item = items[i]
            }

        }
    }

    return item

}